import { PrimaryLink } from 'components';
import { TEXT } from 'locales/translations';
import { linkHandler } from 'utils/linkHandler';

const NoSubscription = () => (
  <div>
    <div className="pb-3">{TEXT.subscriptionStatus.noSubscriptionTeaser}</div>
    <div className="pb-3">{TEXT.subscriptionStatus.noSubscriptionCta}</div>
    <div className="pb-5">
      <PrimaryLink className="w-100 btn-secondary" to={linkHandler.get('plans')}>
        {TEXT.subscriptionStatus.subscribeButtonText}
      </PrimaryLink>
    </div>
  </div>
);

export default NoSubscription;
